<!-- 手写签名 -->
<template>
    <div v-if="componentsData.type == 15">
        <div class="bg-div" :style="bgStyle">
            <div v-if="componentsData.content.title" class="title-box">{{ componentsData.content.title }}</div>
            <div class="sign-box"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.sign-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    color: #999;
    font-size: 14px;
}
.title-box {
    margin-bottom: 8px;
    font-size: 18px;
    color: #000;
}
</style>
